import type { ColumnFiltersState } from '@tanstack/react-table';
import type { EvaluationCaseParams } from './atoms';

export const DEFAULT_PARAMS: EvaluationCaseParams = {
  page: 1,
  pageSize: 100,
  sortAttribute: 'created_at',
  sortDirection: 'DESC',
};

export const SORT_FIELD_MAP: Record<string, string> = {
  name: 'name',
  evaluationType: 'evaluation_type',
  createdAt: 'created_at',
  updatedAt: 'updated_at',
};

/**
 * Converts TanStack column filter state to API query params.
 * @param {ColumnFiltersState} filters - Column filters from the DataTable
 * @return {Partial<EvaluationCaseParams>} Partial params for the evaluation cases search atom
 */
export const columnFiltersToParams = (
  filters: ColumnFiltersState
): Partial<EvaluationCaseParams> => {
  const params: Partial<EvaluationCaseParams> = {
    evaluationType: undefined,
    createdBy: undefined,
    createdAt: undefined,
    updatedAt: undefined,
  };

  for (const filter of filters) {
    switch (filter.id) {
      case 'evaluationType':
        params.evaluationType = filter.value as string[];
        break;
      case 'createdBy':
        params.createdBy = filter.value as string[];
        break;
      case 'createdAt': {
        const [start, end] =
          (filter.value as [string | null, string | null]) ?? [];
        params.createdAt =
          start || end
            ? { start: start ?? undefined, end: end ?? undefined }
            : undefined;
        break;
      }
      case 'updatedAt': {
        const [start, end] =
          (filter.value as [string | null, string | null]) ?? [];
        params.updatedAt =
          start || end
            ? { start: start ?? undefined, end: end ?? undefined }
            : undefined;
        break;
      }
    }
  }

  return params;
};
